import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

export default class Eqipment extends Component {
  constructor(props) {
    super(props);
    this.state = { tracker: "", spinnerClass: "", dataClass: "collapse" };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          "/equipment/report",
        this.props.data
      )
      .then(response => {
        this.setState({
          tracker: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  tabHeader() {
    return (
      <tr>
        <th className="border p-1 font-weight-bold" width="300px">
          Equipment
        </th>
        <th className="border p-1 font-weight-bold" width="300px">
          Patient
        </th>
        <th className="border p-1 font-weight-bold" width="100px">
          Quantity
        </th>
        <th className="border p-1 font-weight-bold" width="150px">
          Lend Out Date
        </th>
        <th className="border p-1 font-weight-bold" width="150px">
          Returned Date
        </th>
      </tr>
    );
  }

  dateFormatter(params) {
    if (params.value !== null) {
      var arr = params.value.split("-");
      return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
    }
  }

  tabRow() {
    if (this.state.tracker !== "") {
      let status = this.props.data.status;

      return this.state.tracker.map(function(tracker) {
        let eqName = tracker.name;

        return tracker.tracker.map(function(obj) {
          let display = false;
          let indate, outdate;

          if (
            (status === "Returned" && obj.indate !== null) ||
            status === "" ||
            status === "All"
          ) {
            display = true;
            if (obj.indate !== null) {
              var arr = obj.indate.split("-");
              indate = arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
            }

            if (obj.outdate !== null) {
              var arr = obj.outdate.split("-");
              outdate = arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
            }
          } else if (status === "Lent Out" && obj.indate === null) {
            display = true;
            if (obj.indate !== null) {
              var arr = obj.indate.split("-");
              indate = arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
            }

            if (obj.outdate !== null) {
              var arr = obj.outdate.split("-");
              outdate = arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
            }
          }

          if (display)
            return (
              <tr key={obj._id}>
                <td className="border p-1 text-wrap">{eqName}</td>
                <td className="border p-1 text-wrap">[{obj.pno}] {obj.patientname}</td>
                <td className="border p-1">{obj.qty}</td>
                <td className="border p-1 text-wrap">{outdate}</td>
                <td className="border p-1">{indate}</td>
              </tr>
            );
        });
      });
    }

    /////////////////////////
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Equipment Report</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>

        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>{this.tabHeader()}</thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}
